export default "__VITE_ASSET__B2vjYZC1__ 500w";